import React from 'react'
import banner from '../Asset/banner1.jpg'
import './Home.css'
import Product from './Product'

function Home() {
  return (
    <div className='home'>
      <img className='home_image' src={banner} alt="" />
      <div className="home_row">
      <Product
    id="123"
    title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses"
    price={11.95}
    rating={5}
    image='https://m.media-amazon.com/images/I/51aEhyjQGrL._SX316_BO1,204,203,200_.jpg'
    />
      <Product
    id="123"
    title="OnePlus Nord 2T 5G (Jade Fog, 8GB RAM, 128GB Storage)"
    price={`28,999`}
    rating={5}
    image='https://m.media-amazon.com/images/I/41qLZhKF5ZL._AC_SY200_.jpg'
    />

      </div>
      <div className="home_row">
      <Product
    id="123"
    title="Happilo 100% Natural Premium 200g Whole Cashews | Whole Crunchy Cashew | Premium Kaju nuts"
    price={244}
    rating={5}
    image='https://m.media-amazon.com/images/I/71tYPz++3+L._AC_SY200_.jpg'
    />
      <Product
    id="125"
    title="Tata Tea Gold |Premium Assam teas with Gently  Rolled Aromatic Long Leaves "
    price={503}
    rating={4}
    image='https://m.media-amazon.com/images/I/51RcxiQNx9L._AC_SY200_.jpg'
    />
      <Product
    id="126"
    title="Bigmuscles Nutrition Premium Gold Whey Pack of 1Kg Whey Protein Isolate Blend Powder"
    price={1750}
    rating={5}
    image='https://m.media-amazon.com/images/I/61iQby6TUML._AC_SY200_.jpg'
    />

      </div>
      <div className="home_row">
      <Product
    id="127"
    title="Tintin Paperback Boxed Set 23 titles Paperback – 5 February 2019"
    price={7000}
    rating={4}
    image='https://m.media-amazon.com/images/I/71NX2336WjL._AC_SY200_.jpg'
    />
      <Product
    id="128"
    title="Kids Board books- My First Library : Set of 10 Board Books (Box Set)"
    price={389}
    rating={5}
    image='https://m.media-amazon.com/images/I/51KQ5TDlZbL._SX198_BO1,204,203,200_QL40_FMwebp_.jpg'
    />

      </div>
      <div className="home_row">
      <Product
    id="127"
    title="Vu 139 cm (55 inches) The Masterpiece Glo Series 4K Ultra HD Smart Android QLED TV 55QMP (Armani Gold) (2022 Model) | Built in 4.1 Speaker"
    price={59990}
    rating={4}
    image='https://m.media-amazon.com/images/I/61EgFzOnMxL._SX679_.jpg'
    />
      

      </div>
       </div>
  )
}

export default Home
